import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ImageMetaData } from '../../../shared/models/image-metadata';

@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: [
    './signature.component.scss'
  ]
})
export class SignatureComponent implements OnInit {
  @Input() src: string;
  @ViewChild('image') image: ElementRef<HTMLImageElement>;
  @ViewChild('imageContainer') imageContainer: ElementRef<HTMLElement>;

  ready: boolean = false;
  imgWidth: string = '100%';
  imgHeight: string = '100%';

  ngOnInit(): void {

    this.getMeta(this.src).then((meta) => {

      this.setRatio(meta);
      this.ready = true;
    });
  }

  private getMeta(url: string): Promise<ImageMetaData> {
    return new Promise<ImageMetaData>((resolve) => {
      const img = new Image();
      img.addEventListener('load', function () {
        resolve(new ImageMetaData({
          naturalWidth: this.naturalWidth,
          naturalHeight: this.naturalHeight
        }))
      });

      img.src = url;
    })
  }

  private setRatio(meta: ImageMetaData): void {
    const height = this.image.nativeElement.parentElement.clientHeight;
    const width = this.image.nativeElement.parentElement.clientWidth;
    let scaleFactor: number;

    if (meta.naturalWidth > meta.naturalHeight) {
      // Use the width as the const
      scaleFactor = width / meta.naturalWidth;

      this.imgWidth = `${(width)}px`;
      this.imgHeight = `${meta.naturalHeight * scaleFactor}px`;

      this.imageContainer.nativeElement.classList.add('vertical');
    } else {
      // Use height as the const
      scaleFactor = height / meta.naturalHeight;

      this.imgWidth = `${(meta.naturalWidth * scaleFactor)}px`;
      this.imgHeight = `${height}px`;

    }
  }
}